import * as angular from "angular";
import {IController, ITimeoutService} from "angular";
import * as _ from "lodash";
import {ItinerariesTasksSettings} from "../../angular/models/itineraries-tasks-settings.model";
import {ResizeService} from "../../../commons/services/resize-service.service";

export class AgentItineraryTaskListCtrl implements IController {

  tasks: any;
  selectedTaskIds: any;
  searchQuery: any;
  highlightedServiceId: any;
  itinerariesTaskSettings: ItinerariesTasksSettings;
  selectedTab: string;

  onHighlightedChanged: Function;
  onTaskSelectToggle: Function;
  onEditBoundEquipment: Function;

  private internalTaskDayTypes: any;
  private internalTaskRouteTypes: any;
  private internalTaskTypes: any;
  private selectedTaskItemIds: any;

  constructor(private tasksConstants, private $timeout: ITimeoutService, private resizeService: ResizeService) {
  }

  $onInit() {
    this.internalTaskDayTypes = this.tasksConstants.internalTaskDayTypes;
    this.internalTaskRouteTypes = this.tasksConstants.internalTaskRouteTypes;
    this.internalTaskTypes = this.tasksConstants.internalTaskTypes;
    this.selectedTaskItemIds = {};
  }

  $onChanges(changes) {
    if (changes.selectedTaskIds && !changes.selectedTaskIds.isFirstChange()) {
      this.selectedTaskItemIds = {};
      _.forEach(changes.selectedTaskIds.currentValue, (selectedTaskId) => {
        this.selectedTaskItemIds[selectedTaskId] = true;
      });
    }
  };

  isStartEndDay(purpose) {
    return _.includes(this.internalTaskDayTypes, purpose);
  }

  isStartEndRoute(purpose) {
    return _.includes(this.internalTaskRouteTypes, purpose);
  }

  isStartEndDayOrRoute(purpose) {
    return this.isStartEndDay(purpose) || this.isStartEndRoute(purpose);
  }

  onInitTasksContainer() {
    this.$timeout(0).then(() => {
      this.resizeService.resize();
    })
  }

}

angular
  .module('bringoz.admin.agents')
  .component('agentItineraryTaskList', {
    bindings: {
      tasks: '<',
      selectedTaskIds: '<?',
      searchQuery: '<?',
      selectedTab: '<',
      itinerariesTaskSettings: '<',
      highlightedServiceId: '<',
      onHighlightedChanged: '&?',
      onTaskSelectToggle: '&?',
      onEditBoundEquipment: '&?'
    },
    // template: require('./templates/agent-itinerary-task-list.html').default,
    // /* @ngInject */
    template: ($element, $attrs) => {
      return $attrs.template === 'minified' ?
        require('./templates/agent-itinerary-task-list-minify.html').default :
        require('./templates/agent-itinerary-task-list.html').default;
    },
    controller: AgentItineraryTaskListCtrl
  });
